module.exports = __webpack_public_path__ + "static/media/under_development.a27cb392.png";